export default {"src":"/_next/static/media/download.b3e7badf.svg","height":20,"width":20};